(function () {
  function fixLink(a) {
    if (!a) return;
    const visible = (a.textContent || "").trim();
    if (visible) {
      a.setAttribute('aria-label', `${visible} – Instagram-Profil öffnen (neues Fenster)`);
    } else {
      a.setAttribute('aria-label', '@stegmann_mode – Instagram-Profil öffnen (neues Fenster)');
    }
    a.setAttribute('rel', 'noopener noreferrer');
  }

  function run() {
    // sucht nach dem Instafeed-Link
    const sel = 'div[id*="instafeed_app_block"] .instafeed-bottom-link-wrapper > a';
    document.querySelectorAll(sel).forEach(fixLink);
  }

  // Startet, sobald DOM geladen ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Falls Instafeed dynamisch nachlädt (App rendert nachträglich)
  const obs = new MutationObserver(run);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
